export const blockIconsNavigationArrowUpward = (
	<span className='material-symbols-outlined'>arrow_upward</span>
);
